module.exports = __webpack_public_path__ + "10f9dd6c6be3485345e0e34e51ed07a8.png";